const actionTypes = {
  CONNECT_TO_SIGNALR: 'CONNECT_TO_SIGNALR',
};

export default actionTypes;
